/**
 * Given a string, redact all but the first n characters
 * @returns {string}
 * @param str {string}
 * @param n {number}
 */
export function redactString(str, n = 8) {
    return `${str.slice(0, n)}-<redacted>`;
}
